class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
if (!customElements.get('moretta-cart-discount')) {
  customElements.define('moretta-cart-discount', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.querySelector('form').addEventListener('submit', async (event) => {
        event.preventDefault();

        const input = this.querySelector('input');
        const button = this.querySelector('button');
        const message = this.querySelector('[data-discount-message]');
        const code = input.value.trim();

        if (!code || this.busy) return;

        this.busy = true;
        button.disabled = true;
        message.textContent = 'Verifica in corso…';

        const root = window.Shopify.routes.root;
        let updated = false;

        try {
          const currentResponse = await fetch(root + 'cart.js');
          if (!currentResponse.ok) throw new Error();
          const current = await currentResponse.json();

          const applications = (cart) => [
            ...(cart.cart_level_discount_applications || []),
            ...(cart.items || []).flatMap(item =>
              (item.line_level_discount_allocations || [])
                .map(a => a.discount_application)
            )
          ];

          const codes = applications(current)
            .filter(a => a.type === 'discount_code')
            .map(a => a.title);

          const response = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              discount: [...new Set([...codes, code])].join(','),
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });

          if (!response.ok) throw new Error();

          const cart = await response.json();
          updated = true;

          const applied = applications(cart).some(a =>
            a.type === 'discount_code' &&
            a.title.toLowerCase() === code.toLowerCase()
          );

          const drawer = this.closest('cart-drawer');

          if (!cart.sections ||
              Object.values(cart.sections).some(s => !s)) {
            throw new Error();
          }

          drawer.renderContents(cart);

          const field = drawer.querySelector('moretta-cart-discount');
          field.querySelector('input').value = code;
          field.querySelector('[data-discount-message]').textContent = applied
            ? 'Codice applicato.'
            : 'Sconto non applicato ai prodotti: verifica le condizioni del codice. Gli sconti sulla spedizione si verificano al checkout.';

          field.querySelector('input').focus();
        } catch (error) {
          message.textContent = updated
            ? 'Carrello aggiornato, ma il totale non è stato ricaricato. Aggiorna la pagina per verificarlo.'
            : 'Impossibile verificare il codice. Riprova.';
        } finally {
          this.busy = false;
          button.disabled = false;
        }
      });
    }
  });
}
if (!window.morettaRemoveDiscountReady) {
  window.morettaRemoveDiscountReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-remove-discount]');
    if (!button) return;

    const field = button.closest('moretta-cart-discount');
    const drawer = button.closest('cart-drawer');

    if (!field || !drawer || field.busy) return;

    const message = field.querySelector('[data-discount-message]');
    field.busy = true;
    button.disabled = true;
    message.textContent = 'Rimozione in corso…';

    let updated = false;

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            discount: '',
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        }
      );

      if (!response.ok) throw new Error();

      const cart = await response.json();
      updated = true;

      if (!cart.sections ||
          Object.values(cart.sections).some(s => !s)) {
        throw new Error();
      }

      drawer.renderContents(cart);

      const newField = drawer.querySelector('moretta-cart-discount');
      newField.querySelector('input').value = '';
      newField.querySelector('[data-discount-message]').textContent =
        'Codici sconto rimossi.';

      newField.querySelector('input').focus();
    } catch (error) {
      message.textContent = updated
        ? 'Codici rimossi. Aggiorna la pagina per vedere il totale aggiornato.'
        : 'Impossibile rimuovere il codice. Riprova.';
    } finally {
      field.busy = false;
      button.disabled = false;
    }
  });
}